import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Inject, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatTable } from '@angular/material/table';
import { LocalStorageService } from 'src/app/local-storage.service';
import { ServiceProviderAssessmentContactPersonDialogComponent } from '../service-provider-assessment-contact-person-dialog/service-provider-assessment-contact-person-dialog.component';
import { ServiceProviderSubjectService } from 'src/services/service-provider-subject.service';
import { ToastrImplService } from 'src/services/toastr.service';

@Component({
  selector: 'app-service-provider-intake-assessment-dialog',
  templateUrl: './service-provider-intake-assessment-dialog.component.html',
  styleUrls: ['./service-provider-intake-assessment-dialog.component.scss']
})
export class ServiceProviderIntakeAssessmentDialogComponent implements OnInit {
  isLoading = false;
  firstStep: FormGroup;
  secondStep: FormGroup;
  thirdStep: FormGroup;
  fourthStep: FormGroup;
  fifthStep: FormGroup;
  sixthStep: FormGroup;
  seventhStep: FormGroup;
  eighthStep: FormGroup;
  ninthStep: FormGroup;
  tenthStep: FormGroup;
  isEditMode = false;
  maxDate: Date = new Date(2999, 11, 31);

  @Input() formNumber: any;
  @Input() approved: boolean;
  @Output() handleSubmitData = new EventEmitter();
  @Output() handleSaveChanges = new EventEmitter();
  @Output() handleFormNumberChange = new EventEmitter<number>();
  @ViewChild('submitButton1') submitButton1;
  @ViewChild('submitButton2') submitButton2;

  subject: any;
  professionalWorkerName: any;
  showDate: any;
  currentDate = new Date();
  relationshipOptions = [];
  intakeAssessmentForm: any = {};

  contactPersons: FormArray;
  @ViewChild('contactPersonTable') contactPersonTable: MatTable<any>;
  contactPersonDataSource: any[] = [];
  displayedContactColumns = ['name', 'kinship', 'address', 'phone', 'email', 'actions'];

  constructor(
    private formBuilder: FormBuilder,
    private localStorageService: LocalStorageService,
    private dialogRef: MatDialogRef<ServiceProviderIntakeAssessmentDialogComponent>,
    private datePipe: DatePipe,
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private serviceProviderSubjectService: ServiceProviderSubjectService,
    private toastr: ToastrImplService
  ) { 
    this.showDate = this.datePipe.transform(this.currentDate, 'yyyy-MM-dd');
    this.professionalWorkerName = (JSON.parse(this.localStorageService.get('loggedUser'))).firstName + ' ' + (JSON.parse(this.localStorageService.get('loggedUser'))).lastName;
    this.subject = data?.subject;
  }

  ngOnInit(): void {
    this.createForms();
  }

  loadData(data: any) {
    if (!data) {
      this.intakeAssessmentForm = {};
  
      this.contactPersons.clear();
      this.contactPersonDataSource = [];
  
      return;
    }
    
    this.intakeAssessmentForm = data;
    this.contactPersons.clear();

    if (this.intakeAssessmentForm.contactPersons && this.intakeAssessmentForm.contactPersons.length > 0) {
      this.intakeAssessmentForm.contactPersons.forEach(cp => {
        this.contactPersons.push(
          this.formBuilder.group({
            id: [cp.id],
            name: [cp.name],
            kinship: [cp.kinship],
            address: [cp.address],
            phone: [cp.phone],
            email: [cp.email]
          })
        );
      });
    }
    this.contactPersonDataSource = [...this.contactPersons.controls];
    if (this.contactPersonTable) {
      this.contactPersonTable.renderRows();
    }
    
    this.thirdStep.patchValue({
      userAndSignificantOthersExpectations: this.intakeAssessmentForm.userAndSignificantOthersExpectations
    });

    this.fourthStep.patchValue({
      userEligibility: this.intakeAssessmentForm.userEligibility
    });

    this.fifthStep.patchValue({
      serviceProviderCapacity: this.intakeAssessmentForm.serviceProviderCapacity
    });

    this.sixthStep.patchValue({
      admissionPriority: this.intakeAssessmentForm.admissionPriority
    });

    this.seventhStep.patchValue({
      userAbilitiesAndPriorityNeeds: this.intakeAssessmentForm.userAbilitiesAndPriorityNeeds
    });

    this.eighthStep.patchValue({
      alternativeServicesAvailability: this.intakeAssessmentForm.alternativeServicesAvailability
    });

    this.ninthStep.patchValue({
      significantOthersAssessment: this.intakeAssessmentForm.significantOthersAssessment
    });

    this.tenthStep.patchValue({
      intakeAssessmentOutcome: this.intakeAssessmentForm.intakeAssessmentOutcome
    });

  }

  createForms() {  
    this.contactPersons = this.formBuilder.array([]);
    this.firstStep = this.formBuilder.group({
      serviceProvider: [this.subject.serviceProviderName, [Validators.required]],
      dateOfSubmission: [this.showDate, [Validators.required]],
      firstName: [this.subject.firstName, []],
      lastName: [this.subject.lastName, []],
      parentName: [this.subject.parentName, []],
      gender: [this.subject.gender, []],
      dateOfBirth: [this.subject.dateOfBirth, []],
      jmbg: [this.subject.jmbg, []],
      permanentResidence: [this.subject.permanentResidence, []],
      phone: [this.subject.phone, []],
      residence: [this.subject.residence, []],
      nationality: [this.subject.nationality, []],
      citizenship: [this.subject.citizenship, []],
      language: [this.subject.language, []],
      education: [this.subject.education, []],
      employment: [this.subject.employment, []],
      ableToWork: [this.subject.ableToWork, []],
      maritalStatus: [this.subject.maritalStatus, []]
    });

    this.secondStep = this.formBuilder.group({
      contactPersons: this.contactPersons,
    });

    this.thirdStep = this.formBuilder.group({
      userAndSignificantOthersExpectations: ['', []],
    });

    this.fourthStep = this.formBuilder.group({
      userEligibility: ['', []],
    });

    this.fifthStep = this.formBuilder.group({
      serviceProviderCapacity: ['', []],
    });

    this.sixthStep = this.formBuilder.group({
      admissionPriority: ['', []],
    });

    this.seventhStep = this.formBuilder.group({
      userAbilitiesAndPriorityNeeds: ['', []],
    });

    this.eighthStep = this.formBuilder.group({
      alternativeServicesAvailability: ['', []],
    });

    this.ninthStep = this.formBuilder.group({
      significantOthersAssessment: ['', []]
    });

    this.tenthStep = this.formBuilder.group({
      intakeAssessmentOutcome: ['', []],
    });

    this.serviceProviderSubjectService.getIntakeAssessmentForm(this.subject.id).subscribe(result => this.loadData(result));
  }

  addContactPerson() {
    const dialogRef = this.dialog.open(ServiceProviderAssessmentContactPersonDialogComponent, {
      width: '500px',
      disableClose: true,
      data: null,
      panelClass: 'responsive-dialog',
    });
  
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.contactPersons.push(
          this.formBuilder.group({
            id: [null],            
            name: [result.name],
            kinship: [result.kinship],
            address: [result.address],
            phone: [result.phone],
            email: [result.email]
          })
        );
        this.contactPersonDataSource = [...this.contactPersons.controls];
        if (this.contactPersonTable) {
          this.contactPersonTable.renderRows();
        }
      }
    });
  }
    
  editContactPerson(index: number) {
    const cp = this.contactPersons.at(index).value;
  
    const dialogRef = this.dialog.open(ServiceProviderAssessmentContactPersonDialogComponent, {
      width: '500px',
      disableClose: true,
      data: cp,
      panelClass: 'responsive-dialog',
    });
  
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        const existingId = this.contactPersons.at(index).value.id;
        this.contactPersons.at(index).patchValue({
          id: existingId,
          name: result.name,
          kinship: result.kinship,
          address: result.address,
          phone: result.phone,
          email: result.email
        });
        this.contactPersonDataSource = [...this.contactPersons.controls];
        this.contactPersonTable.renderRows();
      }
    });
  }
    
  removeContactPerson(index: number) {
    this.contactPersons.removeAt(index);
    this.contactPersonDataSource = [...this.contactPersons.controls];
    this.contactPersonTable.renderRows();
  }

  compareRelationshipObjects(object1: any, object2: any) {
    return object1 && object2 && object1.id === object2.id && object1.title === object2.title;
  }

  preview(){        
    const submittedData = this.createObject(false);
    this.serviceProviderSubjectService.previewIntakeAssessmentForm(submittedData);
  }

  createObject(isFinished: boolean){
    const submittedData = {
      id: (this.intakeAssessmentForm?.id !== null && this.intakeAssessmentForm?.id !== undefined) ? this.intakeAssessmentForm?.id : null,
      dateOfSubmission: this.firstStep.value.dateOfSubmission,
      serviceProviderId: this.subject.serviceProviderId,
      serviceProviderSubjectId: this.subject.id,
      contactPersons: this.contactPersons.value.map(cp => ({
        id: cp.id ?? null,
        name: cp.name,
        kinship: cp.kinship ?? null,
        address: cp.address,
        phone: cp.phone,
        email: cp.email
      })),
      userAndSignificantOthersExpectations: this.thirdStep.value.userAndSignificantOthersExpectations,
      userEligibility: this.fourthStep.value.userEligibility,
      serviceProviderCapacity: this.fifthStep.value.serviceProviderCapacity,
      admissionPriority: this.sixthStep.value.admissionPriority,
      userAbilitiesAndPriorityNeeds: this.seventhStep.value.userAbilitiesAndPriorityNeeds,
      alternativeServicesAvailability: this.eighthStep.value.alternativeServicesAvailability,
      significantOthersAssessment: this.ninthStep.value.significantOthersAssessment,
      intakeAssessmentOutcome: this.tenthStep.value.intakeAssessmentOutcome,
      professionalWorkerName: this.professionalWorkerName,
      finished: isFinished,
    };
    return submittedData;
  }

  save(isFinished: any) {
    const submittedData = this.createObject(isFinished);
    this.serviceProviderSubjectService.submitIntakeAssessmentForm(submittedData).subscribe(
      (result) => {
        if (isFinished) {
          this.toastr.success('SERVICE_PROVIDERS.INTAKE_ASSESSMENT_FORM.GENERATE_SUCCESS');
          this.handleSaveChanges.emit({ step: 'STEP_02', isFinished: true, saved: true });
        } else {
          this.toastr.success('VS.INITIAL_ASSESSMENT.FORMS23.SAVED');
          this.handleSaveChanges.emit({ step: 'STEP_02', isFinished: false, saved: true });
        }
        this.dialogRef.close(result);
      }, () => {
        this.submitButton1.disabled = false;
        this.submitButton2.disabled = false;
        this.toastr.error('SNACKBAR.ERROR_OCCURRED');
      }
    );
  }

  handleSubmit() {
    this.submitButton1.disabled = true;
    this.submitButton2.disabled = true;
    this.save(true);
  }

  closeForm() {
    this.isEditMode = false;
    this.dialogRef.close();
  }

}
